// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_DeleteImageResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/products/deleteImage
 *
 * Confirms the deleted image's id so the frontend can update its
 * gallery cache without re-fetching. If the deleted image was the
 * product's primary, the controller promoted the lowest sort_order
 * sibling to primary — `new_primary_image_id` reports that id (null
 * when no siblings remain).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_DeleteImageResponseDados {
so_product_image_id: number
new_primary_image_id?: number
}

export type Products_DeleteImageResponse = ApiResponse<Products_DeleteImageResponseDados>;

registerResponseContract('Products_DeleteImageResponse', {
  so_product_image_id:  { type: 'number',  required: true },
  new_primary_image_id: { type: 'number',  required: false },
})
